import { render, staticRenderFns } from "./ManterFeriado.vue?vue&type=template&id=52d79c7b&scoped=true&"
import script from "./ManterFeriado.vue?vue&type=script&lang=js&"
export * from "./ManterFeriado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d79c7b",
  null
  
)

export default component.exports